import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Box,
  Switch,
  FormControlLabel,
  styled,
} from '@mui/material';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: theme.palette.primary.main,
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.info.main,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const FollowedFilter = ({ checked, onChange, mode = 'followed' }) => {
  const getLabel = () => {
    switch (mode) {
      case 'favorites':
        return 'Favorites:';
      case 'identified':
        return 'Identified:';
      case 'followed':
      default:
        return 'Followed:';
    }
  };

  const getAriaLabel = () => {
    switch (mode) {
      case 'favorites':
        return 'favorites filter';
      case 'identified':
        return 'identified filter';
      case 'followed':
      default:
        return 'followed artists filter';
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography variant="body1" color="white" fontWeight="bold">
        {getLabel()}
      </Typography>
      <FormControlLabel
        control={
          <IOSSwitch
            checked={checked}
            onChange={onChange}
            inputProps={{ 'aria-label': getAriaLabel() }}
          />
        }
        label=""
        sx={{ m: 0 }}
      />
    </Box>
  );
};

FollowedFilter.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(['followed', 'favorites', 'identified']),
};

export default FollowedFilter;
